<template>
  <div>
    <title-edit header="Membership rate" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_en" @update="updateDetailEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_th" @update="updateDetailTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>One day pass* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.one_day_pass" @update="updateOneDayPass" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Annual fee* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.annual_fee" @update="updateAnnualFee" />
      </v-col>
    </div>
    <line-hr />
    <div class="row" style="margin-right: 30px">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteMembershipRate" />
<!--      <preview-button />-->
      <save-button @click.native="saveMembershipRate" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputEditor from "../../../components/Input/InputEditor";
import InputTextField from "../../../components/Input/InputTextField";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import SwitchSelect from "../../../components/Input/StyleUtility";

export default {
  name: "MembershipRateEdit",
  components: {
    SwitchSelect,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputTextField,
    InputEditor,
    SelectOption,
    LineHr,
    TitleEdit
  },
  computed: {
    ...mapState({
      form: state => state.MembershipRate.form
    })
  },
  data() {
    return {
      optionBranch: []
    };
  },
  created() {
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.branch_id,
            text: `${type.branch_name_th} (${type.branch_name_en})`
          }))
        ];
      });
    },
    validateSave() {
      // if (!this.form.branch_id) {
      //   alert("please select Branch !");
      //   return false;
      // }
      if (!this.form.detail_th) {
        alert("please insert Description TH !");
        return false;
      }
      if (!this.form.detail_en) {
        alert("please insert Description EN !");
        return false;
      }
      if (!this.form.one_day_pass) {
        alert("please insert One day pass !");
        return false;
      }

      return true;
    },
    saveMembershipRate() {
      this.$store
        .dispatch("MembershipRate/saveMembershipRate", {
          id: this.form.id,
          data: this.form
        })
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToMembershipRateTable();
          } else {
            alert(res.response_msg);
          }
        });
    },
    goToMembershipRateTable() {
      this.$router.push("/membership/membership-rate");
    },
    deleteMembershipRate() {
      this.$store
        .dispatch("MembershipRate/deleteMembershipRate", this.form.id)
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToMembershipRateTable();
          }
        })
        .catch(() => {
          alert("delete data fail!");
        });
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateDetailEN(val) {
      this.form.detail_en = val;
    },
    updateDetailTH(val) {
      this.form.detail_th = val;
    },
    updateOneDayPass(val) {
      this.form.one_day_pass = val;
    },
    updateAnnualFee(val) {
      this.form.annual_fee = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/switch.css";
</style>
